
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<h1>{`Modules`}</h1>
<p>{`Always use `}<inlineCode parentName="p">{`import/export`}</inlineCode>{` when writing code for a browser. When writing code for a node app, it's still preferred but not enforced.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
const isEqual = require('lodash/isEqual');
const { uniq } = require('lodash');

// Good
import isEqual from 'lodash/isEqual';
import { uniq } from 'lodash/isEqual';
`}</code></pre>
<p>{`Always use single line export instructions.`}</p>
<pre><code parentName="pre" {...{}}>{`export foo from './utils';
export { bar as default } from './utils';
export { baz } from './utils';
`}</code></pre>
<p>{`Don't rename exports.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
export { foo as bar } from './utils';

// Good
export { foo } from './utils';
`}</code></pre>
<p>{`All named exports should come above the default export.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
export default function foo() {
  // ... more code ...
}

export function bar() {
  // ... more code ...
}

// Good
export function bar() {
  // ... more code ...
}

export default function foo() {
  // ... more code ...
}
`}</code></pre>
<p>{`Only import from a path in one place.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
import foo from './utils';
import { bar } from './utils';

// Good
import foo, { bar } from './utils';
`}</code></pre>
<p>{`Put all `}<inlineCode parentName="p">{`import`}</inlineCode>{` statements above all other statements.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
import foo from './foo';
foo();

import bar from './bar';

// Good
import foo from './foo';
import bar from './bar';

foo();
`}</code></pre>
<p>{`Prefix all interal functions of a module with `}<inlineCode parentName="p">{`_`}</inlineCode>{`.`}</p>
<blockquote>
<p parentName="blockquote">{`Why? Because, even though it's easy to see which functions are internal and which functions are not when looking at the module code and noticing the exported ones, it's not that easy when looking at where those functions are used.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  // ... more code ...
}

export function bar() {
  return foo();
}

// Good
function _foo() {
  // ... more code ...
}

export function bar() {
  return _foo();
}
`}</code></pre>
<p>{`When exporting named exports, always favor exporting in the same line as the definition.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  // ... more code ...
}

export { foo };

// Good
export function foo() {
  // ... more code ...
}
`}</code></pre>
<p>{`Favor exporting functions through an `}<inlineCode parentName="p">{`index.js`}</inlineCode>{` file instead of having to import them directly.`}</p>
<pre><code parentName="pre" {...{}}>{`// index.js
export Foo from './Foo';

// Bad
import Foo from './utils/Foo';

// Good
import { Foo } from './utils';
`}</code></pre>
<p>{`Always be consistent in the order of imports. First, external imports and below, project imports.`}</p>
<blockquote>
<p parentName="blockquote">{`If using webpack and importing non JavaScript modules, those would come at the bottom.`}</p>
</blockquote>
<pre><code parentName="pre" {...{}}>{`// Bad
import { foo } from './utils';
import bar from './bar';
import styles from './styles.css';
import path from 'path';

// Good
import path from 'path';

import { foo } from './utils';
import bar from './bar';

import styles from './styles.css';
`}</code></pre>
<p>{`If being forced to use `}<inlineCode parentName="p">{`require`}</inlineCode>{`, always favor following the same rules as above.`}</p>
<pre><code parentName="pre" {...{}}>{`// Bad
function foo() {
  const bar = require('bar');
  return bar;
}

// Good
const bar = require('bar');

function foo() {
  return bar;
}

// Bad
const bar = require('bar');
const baz = bar.baz;

const baz = require('bar').baz;

// Good
const { baz } = require('bar');
`}</code></pre>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;